module.exports = __webpack_public_path__ + "img/smartland.6604bc0b.jpg";